export const TransitionEffect = {
  FadeThroughWhite: 0,
  FadeThroughBlack: 1,
  Cut: 2
} as const;

export const TransitionEffectLabels = {
 [TransitionEffect.FadeThroughWhite]: 'Fade through white',
 [TransitionEffect.FadeThroughBlack]: 'Fade through black',
 [TransitionEffect.Cut]: 'Cut',
} as const;

export type TransitionEffect = typeof TransitionEffect[keyof typeof TransitionEffect];
